import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { deleteWorkflow } from "src/business/workflow/apiWorkflow";
import { DeleteConfirm } from "src/components/DeleteConfirm";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { workflowCardPageStore as pageStore } from "./workflowCardPageStore";

export const WorkflowCardActions: React.FC = observer(() => {
  const navigate = useNavigate();
  const [delOpen, setDelOpen] = React.useState(false);
  const doDelete = async () => {
    await deleteWorkflow(pageStore.workflowId);
    pageStore.setHasChanges(false);
    navigate(makeUrl(PageUrl.managementWorkflows), { replace: true });
  };
  const items: MenuProps["items"] = [
    {
      key: "delete",
      label: "Удалить",
      danger: true,
      icon: <DeleteOutlined />,
      disabled: !pageStore.canDelete,
      onClick: () => setDelOpen(true),
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
      <DeleteConfirm
        open={delOpen}
        close={() => setDelOpen(false)}
        content={pageStore.msgDelete}
        task={doDelete}
      />
    </>
  );
});
